// 高雄市AI素養爭霸賽
import { News } from "./News";

export const AIcontest = () => {
  // const [allNews, setAllNews] = useState<any[]>([]);
  // const [filteredNews, setFilteredNews] = useState<any[]>([]);
  // const [query, setQuery] = useState('');

  // const handleReset = () => {
  //   setQuery('');
  //   setFilteredNews(allNews);
  // }


  // const handleKeywordSearch = (keyword: string) => {
  //   setQuery(keyword);
  //   const filtered = allNews.filter((item) =>
  //     item.title.includes(keyword) || item.content.includes(keyword)
  //   );
  //   setFilteredNews(filtered);
  // }

  return (
    <div>
      <div className="mb-20">
        <div className="flex items-center staticBanner bg-[#fdfbc9] relative">
          <div className="staticBannerContent">
            <img
              src="/images/resourceBanner.png"
              alt="banner"
              className="staticBannerImg"
            />
            <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-[45%] max-h-full">
              <h2 className=" font-black text-primaryDark leading-tight ">高雄市AI素養爭霸賽</h2>
              {/* <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
                透過我們的平台，學生只需一個帳號即可使用天下雜誌群知識庫、均一教育平台等多種數位資源，享受無縫學習體驗，拓展知識，培養技能，為未來成長打下堅實基礎。
              </p> */}
            </div>
          </div>
        </div>
        {/* <div className="staticSection !pb-0">
          <div className="sectionContent">
            <div className="border-2 border-headline relative text-base sm:text-2xl">
              <div className="flex justify-center items-center font-bold absolute left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-2 text-Headline text-nowrap">
                <span className="text-[0.55em]">〇〇〇</span>
                <h3 className="px-1">研習資訊</h3>
                <span className="text-[0.55em]">〇〇〇</span>
              </div>

              <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-x-24 px-6 py-12 sm:py-20">
                <div className="mx-auto sm:mx-0 text-[0.9em]">
                  <a href="">
                    <button className="roundedAnimationBtn bg-sky-400 text-white  flex-1">
                      <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                        <img src="/images/doc.svg" alt="" className="w-32 h-full object-contain object-center" />
                      </div>
                      <div className="grow ">研習公文</div>
                    </button>
                  </a>
                </div>

                <div className="mx-auto sm:mx-0 text-[0.9em]">
                  <a href="">
                    <button className="roundedAnimationBtn bg-primary text-white  flex-1">
                      <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                        <img src="/images/session.svg" alt="" className="w-32 h-full object-contain object-center" />
                      </div>
                      <div className="grow ">研習場次</div>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}


        <div className='content text-Headline px-4 mx-auto'>
          <div className='text-lg lg:text-3xl w-fit border-b-4 border-primary font-medium mt-6 mb-4 lg:my-12 p-1 lg:p-3 mx-auto'>高雄市AI素養爭霸賽</div>
          {/* <div className="flex justify-center mb-6 lg:mb-8">
            <div className="hidden md:block md:w-auto lg:w-56 sm:mr-auto"></div> */}

          {/* Search box */}
          {/* <div className="flex-grow w-full sm:w-auto sm:max-w-96 mx-auto">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span id="basic-addon1" className="input-group-text !pr-0">
                    <img src={searchIcon} alt="" />
                  </span>
                </div>
                <input
                  type="text"
                  placeholder="主旨、內容關鍵字搜尋"
                  className="form-control"
                  onChange={(e) => handleKeywordSearch(e.target.value)}
                  value={query}
                />
                <div>
                  <button
                    type="button"
                    className="flex py-2 px-3 border border-l-0 border-[#ced4da] rounded-r-full"
                    onClick={() => handleReset()}
                  >
                    <img src={refreshIcon} alt="" />
                  </button>
                </div>
              </div>
            </div> 

          </div>*/}
          <News tag='高雄市AI素養爭霸賽' />

          {/* <div className="text-center mt-8">
            
            <div className="text-primary">共{filteredNews.length}筆</div>
            
          </div> */}

        </div>

      </div>
    </div>
  );
};
